import type { AppManifest, RouterData } from '@wix/editor-platform-sdk-types'
import typeManifest from './typeManifest'
import pagesManifest from './pagesManifest'
import routersManifest from './routersManifest'
import controllersStageDataManifest from './controllersStageDataManifest'
import type {
  EditorSDK,
  I18n,
  Logger,
} from '@wix/wix-data-client-common-standalone'
import type { CollectionsApi } from '@wix/wix-code-collections-api'
import type { Features } from '@wix/wix-data-client-common'
import type Experiments from '@wix/wix-experiments'
import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'

const getAppManifest = async ({
  hostname,
  t,
  experimentsManager,
  editorSdkProxy,
  bindingDefinitions,
  collectionsApi,
  routers,
  features,
  logger,
}: {
  hostname: string
  t: I18n['t']
  experimentsManager: Experiments
  editorSdkProxy: EditorSDK
  bindingDefinitions: Record<string, DataBindingComponentModel>
  collectionsApi: CollectionsApi
  routers: RouterData[] | undefined
  features: Features
  logger: Logger
}): Promise<AppManifest> => ({
  exports: typeManifest() as AppManifest['exports'],
  routers: features.pagesManifest
    ? ((await routersManifest(
        hostname,
        t,
        experimentsManager,
        editorSdkProxy,
      )) as AppManifest['routers'])
    : undefined,
  pages: features.pagesManifest
    ? ((await pagesManifest({
        hostname,
        t,
        collectionsApi,
        routers,
        editorSdkProxy,
        experimentsManager,
        logger,
      })) as AppManifest['pages'])
    : undefined,
  controllersStageData: (await controllersStageDataManifest(
    t,
    experimentsManager,
    editorSdkProxy,
    bindingDefinitions,
    features,
  )) as AppManifest['controllersStageData'],
})

export default getAppManifest
